import React, { createContext, useContext, useMemo } from 'react';
import { fmtMoney, fmtMoneyLabel, fmtCompactMoney } from '../lib/format';
import { DEFAULT_CURRENCY } from '../lib/currency';

const CurrencyContext = createContext(DEFAULT_CURRENCY);

// Wrap a (usually single-project) view to format all money in that currency.
export function CurrencyProvider({ currency, children }) {
  const code = (currency || DEFAULT_CURRENCY).toUpperCase();
  return <CurrencyContext.Provider value={code}>{children}</CurrencyContext.Provider>;
}

export function useCurrencyCode() {
  return useContext(CurrencyContext);
}

// Convenience hook: returns currency-bound formatters.
export function useMoney() {
  const code = useContext(CurrencyContext);
  return useMemo(() => ({
    code,
    money: (fils, decimals = 2) => fmtMoney(fils, code, decimals),
    moneyLabel: (fils, decimals = 2) => fmtMoneyLabel(fils, code, decimals),
    compact: (fils) => fmtCompactMoney(fils, code),
  }), [code]);
}
